import { render, staticRenderFns } from "./ApproveCancelServicesReservation.vue?vue&type=template&id=b27f0e98&scoped=true&"
import script from "./ApproveCancelServicesReservation.vue?vue&type=script&lang=js&"
export * from "./ApproveCancelServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27f0e98",
  null
  
)

export default component.exports